export enum PrizmCountryIsoCode {
  AD = `AD`,
  AE = `AE`,
  AF = `AF`,
  AG = `AG`,
  AI = `AI`,
  AL = `AL`,
  AM = `AM`,
  AO = `AO`,
  AR = `AR`,
  AT = `AT`,
  AU = `AU`,
  AW = `AW`,
  AZ = `AZ`,
  BA = `BA`,
  BB = `BB`,
  BD = `BD`,
  BE = `BE`,
  BF = `BF`,
  BG = `BG`,
  BH = `BH`,
  BI = `BI`,
  BJ = `BJ`,
  BM = `BM`,
  BN = `BN`,
  BO = `BO`,
  BQ = `BQ`,
  BR = `BR`,
  BS = `BS`,
  BT = `BT`,
  BW = `BW`,
  BY = `BY`,
  BZ = `BZ`,
  CD = `CD`,
  CF = `CF`,
  CG = `CG`,
  CH = `CH`,
  CI = `CI`,
  CL = `CL`,
  CM = `CM`,
  CN = `CN`,
  CO = `CO`,
  CR = `CR`,
  CU = `CU`,
  CV = `CV`,
  CW = `CW`,
  CY = `CY`,
  CZ = `CZ`,
  DE = `DE`,
  DJ = `DJ`,
  DK = `DK`,
  DM = `DM`,
  DO = `DO`,
  DZ = `DZ`,
  EC = `EC`,
  EE = `EE`,
  EG = `EG`,
  ER = `ER`,
  ES = `ES`,
  ET = `ET`,
  FI = `FI`,
  FJ = `FJ`,
  FK = `FK`,
  FM = `FM`,
  FR = `FR`,
  GA = `GA`,
  GB = `GB`,
  GD = `GD`,
  GE = `GE`,
  GH = `GH`,
  GI = `GI`,
  GL = `GL`,
  GM = `GM`,
  GN = `GN`,
  GQ = `GQ`,
  GR = `GR`,
  GT = `GT`,
  GW = `GW`,
  GY = `GY`,
  HK = `HK`,
  HN = `HN`,
  HR = `HR`,
  HT = `HT`,
  HU = `HU`,
  ID = `ID`,
  IE = `IE`,
  IL = `IL`,
  IN = `IN`,
  IQ = `IQ`,
  IR = `IR`,
  IS = `IS`,
  IT = `IT`,
  JM = `JM`,
  JO = `JO`,
  JP = `JP`,
  KE = `KE`,
  KG = `KG`,
  KH = `KH`,
  KM = `KM`,
  KN = `KN`,
  KP = `KP`,
  KR = `KR`,
  KW = `KW`,
  KY = `KY`,
  KZ = `KZ`,
  LA = `LA`,
  LB = `LB`,
  LC = `LC`,
  LI = `LI`,
  LK = `LK`,
  LR = `LR`,
  LS = `LS`,
  LT = `LT`,
  LU = `LU`,
  LV = `LV`,
  LY = `LY`,
  MA = `MA`,
  MC = `MC`,
  MD = `MD`,
  ME = `ME`,
  MG = `MG`,
  MK = `MK`,
  ML = `ML`,
  MM = `MM`,
  MN = `MN`,
  MO = `MO`,
  MR = `MR`,
  MS = `MS`,
  MT = `MT`,
  MU = `MU`,
  MV = `MV`,
  MW = `MW`,
  MX = `MX`,
  MY = `MY`,
  MZ = `MZ`,
  NA = `NA`,
  NE = `NE`,
  NG = `NG`,
  NI = `NI`,
  NL = `NL`,
  NO = `NO`,
  NP = `NP`,
  NZ = `NZ`,
  OM = `OM`,
  PA = `PA`,
  PE = `PE`,
  PF = `PF`,
  PG = `PG`,
  PH = `PH`,
  PK = `PK`,
  PL = `PL`,
  PT = `PT`,
  PW = `PW`,
  PY = `PY`,
  QA = `QA`,
  RO = `RO`,
  RS = `RS`,
  RU = `RU`,
  RW = `RW`,
  SA = `SA`,
  SB = `SB`,
  SC = `SC`,
  SD = `SD`,
  SE = `SE`,
  SG = `SG`,
  SH = `SH`,
  SI = `SI`,
  SK = `SK`,
  SL = `SL`,
  SM = `SM`,
  SN = `SN`,
  SO = `SO`,
  SR = `SR`,
  ST = `ST`,
  SV = `SV`,
  SX = `SX`,
  SY = `SY`,
  SZ = `SZ`,
  TC = `TC`,
  TD = `TD`,
  TG = `TG`,
  TH = `TH`,
  TJ = `TJ`,
  TL = `TL`,
  TM = `TM`,
  TN = `TN`,
  TO = `TO`,
  TR = `TR`,
  TT = `TT`,
  TW = `TW`,
  TZ = `TZ`,
  UA = `UA`,
  UG = `UG`,
  UY = `UY`,
  UZ = `UZ`,
  VC = `VC`,
  VE = `VE`,
  VG = `VG`,
  VN = `VN`,
  VU = `VU`,
  WS = `WS`,
  XK = `XK`,
  YE = `YE`,
  ZA = `ZA`,
  ZM = `ZM`,
  ZW = `ZW`,
  US = `US`,
  CA = `CA`,
}
